var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('ABreadcrumb',{attrs:{"items":_vm.breadcrumbs}}),_c('SlideUpgradeForm'),_c('SlideFooter'),_c('SlideCopyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }